import CustomersList from "@/components/CustomersList";

export default function PartnerCustomers() {
  return <CustomersList role="partner" />;
}
